<template>
    <div class="list-group border-radius-2 no-border">
        <CheckboxInput 
            v-for="role in roles" 
            :key="role.id"
            :label="role.name"
            :value="isSelected(role)" 
            @input="toggleRole(role)"
            class="list-group-item m-0"
            :class="{ 'px-2 py-1': slim }"
        >
            <template v-slot:label>{{ role.name }}</template>
        </CheckboxInput>
    </div>
</template>

<script>
import CheckboxInput from '../Inputs/CheckboxInput.vue';

export default {
    components: {
        CheckboxInput,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        slim: { // If true, reduces inner padding of component rows
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        this.roles = this.$config.getValue('roles')
    },
    data() {
        return {
            innerValue: this.value,
            roles: [],
        }
    },
    methods: {
        isSelected(role) {
            return this.innerValue.findIndex(el => el.id == role.id) > -1
        },
        toggleRole(role) {
            const index = this.innerValue.findIndex(el => el.id == role.id)
            if (index > -1) this.innerValue.splice(index, 1)
            else this.innerValue.push(role)

            this.$emit('input', this.innerValue)
        },
    },
    watch: {
        value(newVal) {
            this.innerValue = newVal
        }
    }
}
</script>